import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/leul-adugna-05900320a/" target="_blank">
        <BsLinkedin />
      </a>
      <a href="https://github.com/LeulAdugna" target="_blank">
        <FaGithub />
      </a>
    </div>
  );
};

export default HeaderSocials;
